import { post } from "./_utils";

export const sendVerificationCode = (uuid, email) => {
  return post(`/forms/${uuid}/email_verification/send_code`, { email });
};

export const verifyCode = (uuid, email, code) => {
  return post(`/forms/${uuid}/email_verification/verify_code`, { email, code });
};
